<div class="wrapper" data-automation-e2e-selector="stockToggle">
  <label
    class="c-switch c-switch-danger"
    data-automation-e2e-selector="toggleLabel"
    for="stockToggle"
  >
    Stock
  </label>
  <div class="toggle" data-automation-e2e-selector="toggleSwitcher">
    <input
      type="checkbox"
      id="stockToggle"
      name="toggle"
      checked
      #chk
      (change)="change.next(chk.checked)"
      [ngModel]="checked | async"
      class="checkbox"
      data-automation-e2e-selector="toggleIndicator"
    />
    <label class="innerLabel" for="stockToggle"> </label>
  </div>
</div>
